import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  meta: {
    title: {
      de: 'Datenschutzerklärung',
      en: 'Privacy Policy'
    },
    description: {
      de: 'Datenschutzerklärung der S+D Holding GmbH - Informationen zur Verwendung Ihrer Daten',
      en: 'Privacy Policy of S+D Holding GmbH - Information on how we use your data'
    }
  },
  title: {
    de: 'Datenschutzerklärung',
    en: 'Privacy Policy'
  }
}); 